export default "<template>\r\n  <div>\r\n    <var>v</var> = <var>u</var> * <var>e</var>\r\n  </div>\r\n</template>\r\n";